/**
 * Gelly product page — sticky ATC, wishlist, transitions
 */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  var mainForm = section.querySelector('form.product-single__form');
  var mainSubmit = section.querySelector('[data-add-to-cart]');
  var stickyBar = document.querySelector('[data-gelly-sticky-atc]');
  var stickySubmit = document.querySelector('[data-gelly-sticky-submit]');
  var stickyPrice = document.querySelector('[data-gelly-sticky-price]');
  var stickyVariant = document.querySelector('[data-gelly-sticky-variant]');
  var stickyText = document.querySelector('[data-gelly-sticky-text]');
  var stickyImage = document.querySelector('[data-gelly-sticky-image]');
  var buyBlock = section.querySelector('[data-add-to-cart]');

  /* Sticky ATC visibility */
  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        stickyBar.hidden = visible;
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
    observer.observe(buyBlock);
  }

  if (stickySubmit && mainForm) {
    stickySubmit.addEventListener('click', function () {
      if (mainSubmit && !mainSubmit.disabled) {
        mainSubmit.click();
      }
    });
  }

  /* Variant sync */
  section.addEventListener('variantChange', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    if (stickyPrice && window.theme && theme.Currency) {
      stickyPrice.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    } else if (stickyPrice && variant.price) {
      stickyPrice.textContent = (variant.price / 100).toFixed(2);
    }
    if (stickyVariant) stickyVariant.textContent = variant.public_title || variant.title;
    if (stickyText) {
      if (!variant.available) {
        stickyText.textContent = stickyText.dataset.soldOut || 'Sold out';
      } else if (variant.inventory_management && variant.inventory_quantity <= 0) {
        stickyText.textContent = stickyText.dataset.preorder || 'Pre-order';
      } else {
        stickyText.textContent = stickyText.dataset.available || 'Add to cart';
      }
    }
    if (stickySubmit) stickySubmit.disabled = !variant.available;
    if (stickyImage && variant.featured_image && variant.featured_image.src) {
      stickyImage.src = variant.featured_image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_120x$1$2');
    }
  });

  if (stickyText) {
    stickyText.dataset.available = stickyText.dataset.available || 'Add to cart';
    stickyText.dataset.preorder = stickyText.dataset.preorder || 'Pre-order';
    stickyText.dataset.soldOut = stickyText.dataset.soldOut || 'Sold out';
  }

  /* Wishlist */
  var storageKey = 'gelly-wishlist';

  function readWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (e) {}
    document.querySelectorAll('[data-gelly-wishlist-count]').forEach(function (el) {
      if (list.length) {
        el.textContent = String(list.length);
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function setWishlistState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  document.querySelectorAll('[data-gelly-wishlist-btn]').forEach(function (btn) {
    var handle = btn.getAttribute('data-product-handle');
    var list = readWishlist();
    setWishlistState(btn, list.indexOf(handle) !== -1);

    btn.addEventListener('click', function () {
      var current = readWishlist();
      var idx = current.indexOf(handle);
      if (idx === -1) {
        current.push(handle);
        setWishlistState(btn, true);
      } else {
        current.splice(idx, 1);
        setWishlistState(btn, false);
      }
      writeWishlist(current);
    });
  });

  /* Recently viewed — theme handles tracking; ensure section initializes */
  if (window.theme && theme.RecentlyViewed) {
    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function (el) {
      if (!el.dataset.gellyRvInit) {
        el.dataset.gellyRvInit = 'true';
      }
    });
  }
})();
